import { fromRestrictionCheckResponse } from '../models/mapper'
import { RestrictionCheck } from '../models/types'
import { validateRestrictionsV3 } from './http'

// eslint-disable-next-line import/prefer-default-export
export async function validateRestrictions(id: number): Promise<RestrictionCheck> {
  const response = await validateRestrictionsV3(id)
  return fromRestrictionCheckResponse(response)
}
